import { create } from 'zustand';

interface ThemeState {
  isDarkMode: boolean;
  toggleDarkMode: () => void;
  loadFromStorage: () => void;
}

export const useThemeStore = create<ThemeState>((set) => ({
  isDarkMode: false,

  toggleDarkMode: () => {
    set((state) => {
      const newDarkMode = !state.isDarkMode;
      localStorage.setItem('theme-storage', JSON.stringify({ state: { isDarkMode: newDarkMode } }));
      
      if (newDarkMode) {
        document.documentElement.classList.add('dark');
      } else {
        document.documentElement.classList.remove('dark');
      }
      
      return { isDarkMode: newDarkMode };
    });
  },

  loadFromStorage: () => {
    // Always sync both Zustand state and the DOM class from persisted storage.
    // Be strict: "false" (string) should NOT enable dark mode.
    let isDarkMode = false;

    try {
      const stored = localStorage.getItem('theme-storage');
      if (stored) {
        const parsed = JSON.parse(stored);
        const raw = parsed?.state?.isDarkMode;
        isDarkMode = raw === true || raw === 'true' || raw === 1;
      }
    } catch (error) {
      console.error('Failed to load theme:', error);
      isDarkMode = false;
    }

    if (isDarkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }

    set({ isDarkMode });
  },
}));

